// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
}

.header__logo {
  display: flex;
  align-items: center;
}

.logo {
  margin-right: 16px;
  text-align: left;
}
.logo img {
  height: 46px;
}

.stats {
  display: flex;
}

.statsItem {
  display: flex;
  flex-direction: column;
  padding: 0 15px;
}
.statsItem + .statsItem {
  border-left: 1px solid #ccc;
}

.statsItem__value {
  font-size: 25px;
}

.statsItem__label {
  font-weight: 400 !important;
  font-size: 18px;
}

.cwchart .info-text {
  margin: 16px 0;
  text-align: left;
}
.cwchart .info-text h3 {
  margin-bottom: 0;
}
.cwchart .info-text p {
  font-weight: 400;
  font-size: 14px;
}
.cwchart .info-text a {
  color: #00a4ff;
  transition: all 0.3s ease;
}
.cwchart .info-text a:hover {
  color: #00ff7f;
}`, "",{"version":3,"sources":["webpack://./src/components/CompanyWatch/chart.scss","webpack://./src/assets/scss/helpers/_variable.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,8BAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,gBAAA;AAFJ;AAII;EACI,YAAA;AAFR;;AAMA;EACI,aAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;AAHJ;AAKI;EACI,2BAAA;AAHR;;AAQA;EACI,eAAA;AALJ;;AAQA;EACI,2BAAA;EACA,eAAA;AALJ;;AAUI;EACI,cAAA;EACA,gBAAA;AAPR;AASQ;EACI,gBAAA;AAPZ;AASQ;EACI,gBAAA;EACA,eAAA;AAPZ;AAUQ;EACI,cChCD;EDiCC,yBAAA;AARZ;AAUY;EACA,cCrCS;AD6BrB","sourcesContent":["@import '../../assets/scss/helpers/component';\n@import '../../assets/scss/helpers/variable';\n\n.header {\n    display: flex;\n    justify-content: space-between;\n}\n\n.header__logo {\n    display: flex;\n    align-items: center;\n}\n\n.logo {\n    margin-right: 16px;\n    text-align: left;\n\n    img {\n        height: 46px;\n    }\n}\n\n.stats {\n    display: flex;\n}\n\n.statsItem {\n    display: flex;\n    flex-direction: column;\n    padding: 0 15px;\n\n    + .statsItem {\n        border-left: 1px solid #ccc;\n    }\n}\n\n\n.statsItem__value {\n    font-size: 25px;\n}\n\n.statsItem__label {\n    font-weight: 400 !important;\n    font-size: 18px;\n}\n\n\n.cwchart {\n    .info-text {\n        margin: 16px 0;\n        text-align: left;\n\n        h3 {\n            margin-bottom: 0;\n        }\n        p {\n            font-weight: 400;\n            font-size: 14px;\n        }\n\n        a {\n            color: $gbp-blue;\n            transition: all .3s ease;\n\n            &:hover {\n            color: $gbp-electric-green;\n            }\n        }\n    }\n}\n","// Fonts colors\n$primary: #415a77;\n$secondary: #2e2e3a;\n$header-background: #415a77;\n$primary-green: #2afca3;\n$light-grey: #f1f4fb;\n$blue: #317af6;\n$light-blue: #89b8f1;\n$light-green: #8ebbf1;\n$border-light: #d3e1fd;\n$white: #fff;\n$sky-blue: #cad8f2;\n$green: #3cc221;\n$red: #f42b03;\n$golden: #ffe13e;\n$pink: #fd6383;\n$dark-blue: #405873;\n$dark-blue-active: #35485e;\n$pale-grey: #f8fafd;\n$table-border: #c5d5f4;\n$highlight-text-color: #2b2b2b;\n$black: #000000;\n$accent4: #fab723;\n$maroon: #bb0611;\n$dark-blue-link: #263546;\n\n\n$gbp-rich-green: #003825;\n$gbp-electric-green: #00ff7f;\n$gbp-blue: #00a4ff;\n\n$table-border: $gbp-electric-green;\n\n$font-family-base: 'MADETOMMY', Arial, sans-serif;\n$font-family-alt: 'HeadingPro', Arial, sans-serif;\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n\n\n$zi-header: 1000;\n$zi-cookie-overlay: 1100;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
